import React, { useState } from "react";
import ModalSkeleton from "../ModalSkeleton";
import classes from "./ChangePassModal.module.css";
import TextArea from "../../Component/TextArea";
import { RxCross2 } from "react-icons/rx";
import { Input } from "../../Component/Input/Input";
import { Button } from "../../Component/Button/Button";
import { useSelector } from "react-redux";
import { apiHeader, BaseURL, capitalizeFirstLetter, formRegEx, formRegExReplacer } from "../../config/apiUrl";
import { Patch } from "../../Axios/AxiosFunctions";
import { toast } from "react-toastify";
const ChangePassModal = ({ show, setShow }) => {
  const { access_token } = useSelector((state) => state?.authReducer);
const [currentPassword, setCurrentPassword] = useState('')
const [password, setPassword] = useState('')
const [confirmPassword, setConfirmPassword] = useState('')
const [isLoading, setIsLoading] = useState(false)
  const [active, setactive] = useState("original");

  const [text, setText] = useState(
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries,"
  );

  const updatePassword=async()=>{
    const url=BaseURL('users/updateMyPassword')
    const params={
      passwordCurrent: currentPassword,
      password:password,
      passwordConfirm: confirmPassword
    }
    for (let key in params) {
      if (params[key]==="" || params[key]===null )
        return toast.error(
          `${capitalizeFirstLetter(
            key?.replace(formRegEx, formRegExReplacer)
          )} can not be empty.`
        );
    }
    if(password!==confirmPassword){
      return toast.error(
        "Passowrd and Confim password does not match"
      );
    }
    setIsLoading(true)
    const response= await Patch(url,params,apiHeader(access_token))
    
    if(response){
      toast.success(
        "Passoword Succesfully Updated"
      );
      setShow(false)
    }
    setIsLoading(false)
  }
  return (
    <div>
      <ModalSkeleton
        setShow={setShow}
        show={show}
        width={"689px"}
        //   header={"Login"}
        borderRadius={"20px"}
        //   showCloseIcon
      >
        <div className={classes.main}>
          <div className={classes.header}>
            <div
              className={[
                classes.btn,
                active === "original" && classes.active,
              ].join(" ")}
              onClick={() => {
                setactive("original");
              }}
            >
              <h3>Change Password</h3>
              <div className={classes.input_main}>
                <Input value={currentPassword} setter={setCurrentPassword} placeholder={"Old Password"} />
                <Input value={password} setter={setPassword} placeholder={"New Password"} />
                <Input value={confirmPassword} setter={setConfirmPassword} placeholder={"Confirm Password"} />
                <Button onClick={updatePassword} green customStyle={{ width: "100%" }} label={isLoading? "Updating...":"Update"} />
              </div>
            </div>
          </div>
          {/* <div
            className={classes.crossBtn}
            onClick={() => {
              setShow(false);
            }}
          >
            <RxCross2 size={20} color={"var(--white-color"} />
          </div> */}
        </div>
      </ModalSkeleton>
    </div>
  );
};

export default ChangePassModal;
